import React from 'react';
import { Modal, Stack, spacing, useTheme } from '@fti/design-system';
import type { ColumnType } from '../../types/columnType';

interface IncompatibilityWarningProps {
  incompatibleCount: number;
  totalCount: number;
  targetType: ColumnType;
  onConfirm: () => void;
  onCancel: () => void;
}

export const IncompatibilityWarning: React.FC<IncompatibilityWarningProps> = ({
  incompatibleCount,
  totalCount,
  targetType,
  onConfirm,
  onCancel,
}) => {
  const { theme } = useTheme();

  return (
    <Modal isOpen={true} onClose={onCancel} aria-labelledby="incompatibility-title">
      <Stack gap="md">
        <h3
          id="incompatibility-title"
          style={{
            margin: 0,
            fontSize: '1.1rem',
            color: theme.colors.text.primary,
          }}
        >
          Incompatible Values Detected
        </h3>
        <p
          style={{
            margin: 0,
            fontSize: '0.9rem',
            color: theme.colors.text.primary,
          }}
        >
          <strong>{incompatibleCount}</strong> of <strong>{totalCount}</strong> values
          are incompatible with the type <strong>&ldquo;{targetType}&rdquo;</strong>.
        </p>
        <p
          style={{
            margin: 0,
            fontSize: '0.85rem',
            color: theme.colors.text.secondary,
          }}
        >
          Changing the type will not modify your data values. Incompatible values will
          remain as-is but may not be recognized for chart operations that expect this type.
        </p>
        <div
          style={{
            display: 'flex',
            gap: spacing.sm,
            justifyContent: 'flex-end',
            marginTop: spacing.sm,
          }}
        >
          <button
            type="button"
            onClick={onCancel}
            style={{
              padding: `${spacing.xs} ${spacing.md}`,
              border: `1px solid ${theme.colors.border.default}`,
              borderRadius: theme.borderRadius.md,
              backgroundColor: 'transparent',
              color: theme.colors.text.primary,
              fontSize: '0.85rem',
              cursor: 'pointer',
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            style={{
              padding: `${spacing.xs} ${spacing.md}`,
              border: 'none',
              borderRadius: theme.borderRadius.md,
              backgroundColor: theme.colors.semantic.warning.default,
              color: '#fff',
              fontSize: '0.85rem',
              fontWeight: 500,
              cursor: 'pointer',
            }}
          >
            Change Type Anyway
          </button>
        </div>
      </Stack>
    </Modal>
  );
};
